module.exports = __webpack_public_path__ + "static/media/F-7ths.773fba95.png";